

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Dashboard React base styles
import colors from "assets/theme/base/colors";

function Hierarchy({ color, size }) {
  return (
    <svg

      viewBox="-4 -2 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >

      <g id="Basic-Elements" stroke="#020202" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="organization">

          <circle class="cls-1" cx="12" cy="4.36" r="2.86" />

          <circle class="cls-1" cx="3.41" cy="20.59" r="1.91" />

          <circle class="cls-1" cx="12" cy="20.59" r="1.91" />

          <circle class="cls-1" cx="20.59" cy="20.59" r="1.91" />

          <polyline class="cls-1" points="3.41 18.68 3.41 12.96 20.59 12.96 20.59 18.68" />

          <line class="cls-1" x1="12" y1="18.68" x2="12" y2="7.23" />

        </g>
      </g>
    </svg>
  );
}

// Setting default values for the props of Office
Hierarchy.defaultProps = {
  color: "dark",
  size: "16px",
};

// Typechecking props for the Office
Hierarchy.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Hierarchy;
